import { AppModal, IconButton, TutorialArrow } from '../';
import { useEarningsStore } from '../../store/gameEarnings.store';
import {
  SessionResultContainer,
  SessionResultControls,
  StyledSessionResultPopup
} from '../SessionResultPopup/SessionResultPopup.styled';
import {
  BattleNowContent,
  BattleNowBackground,
  BattleNowLogo,
  BattleNowLogoWrapper,
  Prepare,
  Caption,
  CaptionText,
  Fight
} from './BattleNowPopup.styled';

const BattleNowPopup = ({ onClose }) => {
  const { battleNowNextLevel: nextLevel } = useEarningsStore();

  const captionByLevel = {
    1: 'BATTLE AGAIN TO UNLOCK NEW ITEMS',
    2: 'FIND AND BATTLE NEW OPPONENTS HERE!',
    3: 'BATTLE AGAIN TO EARN YOUR FIRST WEAPON',
  };
  const caption = captionByLevel[nextLevel] || captionByLevel[1];

  // Highlight menu in post second battle view
  const highlightMenuItem = nextLevel === 2 ? 1 : null;

  return (
    <AppModal>
      <StyledSessionResultPopup $gap={'0'}>
        <BattleNowContent>
          <BattleNowBackground src='/assets/tunnel.gif'/>
          <BattleNowLogoWrapper>
            <BattleNowLogo>
              <Fight src='/assets/fight.png'/>
              <Prepare src='/assets/prepare.png'/>
            </BattleNowLogo>
          </BattleNowLogoWrapper>
          <Caption>
            <div className='decorator' />
            <CaptionText>
              {caption}
            </CaptionText>
          </Caption>
        </BattleNowContent>
        <SessionResultContainer>
          <SessionResultControls>
	          <IconButton onClick={onClose}>
              Battle Now
            </IconButton>
          </SessionResultControls>
        </SessionResultContainer>
      </StyledSessionResultPopup>
      { (typeof highlightMenuItem !== 'undefined') && <TutorialArrow selector={'[data-tutorial-anchor="menu-button-'+highlightMenuItem+'"]'}/>}
    </AppModal>
  );
};

export default BattleNowPopup;

